// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const RadioLookupWrapper = styled.div`
  display: -ms-grid;
  -ms-grid-columns: (1fr 1em)[5] auto;
  -ms-grid-rows: auto 1em auto;

  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "radio-code manufacturer model-family model emission-bandwidth radio-lookup-search"
    "modulation-type modulation throughput power architecture fa";
  grid-template-columns: repeat(5, 1fr) auto;
  grid-template-rows: auto auto;

  > .radio-code {
    grid-area: radio-code;
    -ms-grid-column: 1;
    -ms-grid-row: 3;
  }

  > .manufacturer {
    grid-area: manufacturer;
    -ms-grid-column: 3;
    -ms-grid-row: 3;
  }

  > .model-family {
    grid-area: model-family;
    -ms-grid-column: 5;
    -ms-grid-row: 3;
  }

  > .model {
    grid-area: model;
    -ms-grid-column: 7;
    -ms-grid-row: 3;
  }

  > .emission-bandwidth {
    grid-area: emission-bandwidth;
    -ms-grid-column: 9;
    -ms-grid-row: 3;
  }

  > .radio-lookup-search {
    grid-area: radio-lookup-search;
    -ms-grid-column: 11;
    -ms-grid-row: 3;
  }


  > .modulation-type {
    grid-area: modulation-type;
    -ms-grid-column: 1;
    -ms-grid-row: 6;
  }  

  > .modulation {
    grid-area: modulation;
    -ms-grid-column: 3;
    -ms-grid-row: 4;
  }

  > .throughput {
    grid-area: throughput;
    -ms-grid-column: 5;
    -ms-grid-row: 4;
  }

  > .power {
    grid-area: power;
    -ms-grid-column: 7;
    -ms-grid-row: 4;
  }

  > .architecture {
    grid-area: architecture;
    -ms-grid-column: 9;
    -ms-grid-row: 4;
  }

  > .fa {
    grid-area: fa;
    -ms-grid-column: 11;
    -ms-grid-row: 4;
  }
`
